/**
 * Analytics Plugin for Vue Router
 * Tracks pageviews for main routes only to avoid noise
 */

import { trackPageview } from '@/utils/analytics'
import { TRACKED_ROUTES, ANALYTICS_CONFIG } from '@/config/analytics'

// Track all routes if TRACKED_ROUTES is null, otherwise use the set
const TRACK_ALL_ROUTES = TRACKED_ROUTES === null
const MAIN_ROUTES = TRACK_ALL_ROUTES ? null : new Set(TRACKED_ROUTES)

/**
 * Analytics router plugin
 * @param {Object} router - Vue Router instance
 */
export function setupAnalytics(router) {
    router.afterEach((to) => {
        const isTracked = TRACK_ALL_ROUTES || (to.name && MAIN_ROUTES.has(to.name))
        
        // Track if analytics is enabled and route should be tracked
        if (ANALYTICS_CONFIG.enabled && to.name && isTracked) {
            trackPageview(to.name)
        }
    })
}

export default {
    install(Vue, { router }) {
        setupAnalytics(router)
    },
}
